import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-5 media align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-4 media align-items-center"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "col-4"
}
const _hoisted_7 = { class: "col-3 px-0" }
const _hoisted_8 = { class: "row my-1" }
const _hoisted_9 = {
  key: 0,
  class: "col-12"
}
const _hoisted_10 = {
  key: 1,
  class: "col-12"
}
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.itemName), 1),
      (!_ctx.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.featured == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Yes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "No"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.featured) = $event))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("option", { value: "0" }, "No", -1),
              _createElementVNode("option", { value: "1" }, "Yes", -1)
            ]), 512), [
              [_vModelSelect, _ctx.featured]
            ])
          ])),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.canEdit && !_ctx.edit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit = true)),
              class: "btn btn-link text-primary"
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createTextVNode()),
        (_ctx.canEdit && _ctx.edit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update(_ctx.item.id))),
              class: "btn btn-link text-primary"
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-save" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createTextVNode()),
        (_ctx.canEdit && !_ctx.edit)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: "javascript:void(0)",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.remove(_ctx.item.partner_id))),
              class: "text-danger"
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!_ctx.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Job# " + _toDisplayString(_ctx.item.job_number), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[11] || (_cache[11] = _createTextVNode(" Job# ")),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.job_number) = $event)),
              maxlength: "255",
              class: "job_number_edit"
            }, null, 512), [
              [_vModelText, _ctx.job_number]
            ]),
            (_ctx.job_number_error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.job_number_error), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col-12" }, [
        _createElementVNode("hr")
      ])
    ], -1))
  ], 64))
}